import React, { useState } from 'react'

import {
  Box,
  Button,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core'
import {
  Folder as FolderIcon,
  Clock as ClockIcon,
  Monitor as MonitorIcon,
  Link as LinkIcon,
} from 'react-feather'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import { routes } from 'Routes'
import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

const TrainingCourseCard = ({ course, isEdit }) => {
  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()
  const [copied, setCopied] = useState(false)

  const handleManage = () => {
    history.push(
      reverse(routes.trainingCourses.manage, { courseId: course.id }),
    )
  }

  const inviteLink = course?.inviteCourseUrl

  const handleCopyLink = () => {
    navigator.clipboard.writeText(inviteLink).then(() => {
      setCopied(true)
      snackbar.open({
        message: 'Link de autocadastro copiado!',
        variant: 'success',
      })
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <Box className={classes.card}>
      {course?.thumbnailUrl ? (
        <img
          src={course.thumbnailUrl}
          alt={course.title}
          className={classes.thumbnail}
        />
      ) : (
        <Box className={classes.thumbnailPlaceholder}>
          <MonitorIcon size={36} />
        </Box>
      )}
      <Box className={classes.body}>
        <Box className={classes.categories}>
          {(course?.categories ?? []).slice(0, 2).map((category) => (
            <Chip
              key={category.id}
              label={category.name}
              size="small"
              color="primary"
              className={classes.chip}
            />
          ))}
          {(course?.categories ?? []).length > 2 && (
            <Chip
              label={`+${(course.categories ?? []).length - 2}`}
              size="small"
              className={classes.chip}
            />
          )}
        </Box>
        <Typography className={classes.title}>{course?.title}</Typography>
        <Box className={classes.meta}>
          <Box className={classes.metaItem}>
            <FolderIcon size={12} />
            <Typography className={classes.metaText}>
              {course?.quantityModules} módulos
            </Typography>
          </Box>
          <Box className={classes.metaItem}>
            <ClockIcon size={12} />
            <Typography className={classes.metaText}>
              {course?.courseLoad}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.meta}>
          <Typography className={classes.metaText}>
            Publicado por: <b>{course?.organization?.name}</b>
          </Typography>
        </Box>
        <Box className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.accessButton}
            onClick={handleManage}
          >
            {isEdit ? 'Gerenciar' : 'Visualizar'}
          </Button>
          {inviteLink && (
            <Tooltip
              title={copied ? 'Copiado!' : 'Copiar link de autocadastro'}
            >
              <IconButton
                size="small"
                className={classes.linkButton}
                onClick={handleCopyLink}
              >
                <LinkIcon size={16} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default TrainingCourseCard
